import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import Bem from 'bemHelper';
import { emit } from 'helpers/global-events';
import apiDecorator from 'api/api-decorator';
import DataProvider from 'api/data-provider';
import Form, { InputListBox } from 'containers/form';
import Button, { btnThemes } from 'components/button';
import Row, { Col } from 'components/row';

import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';

const classesBemForm = new Bem('modalContentAdmin');
const bemClassesAdminPane = new Bem('adminPanelForum');

@apiDecorator
class NotificationsContent extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    postId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    posterId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    topicId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    closeModal: PropTypes.func,
    post: PropTypes.string
  };

  onSubmit = () => {
    emit('updateClubPosts');
    if (this.props.closeModal) this.props.closeModal();
  }

  renderUsersWarning({ data }) {
    if (!data || !data.length) return <span />;

    return (
      <div {...bemClassesAdminPane('hint', 'mb')}>
        <div {...bemClassesAdminPane('text')} children="У данного пользователя есть следующие предупреждения:" />
        {map(data, (it, key) => {
          return (
            <Fragment key={key}>
              <div {...bemClassesAdminPane('text', 'italic mt')} children={`от ${it.date_add}`} />
              {map(it.warnings, (warning, w_key) => {
                return (
                  <div
                    key={w_key}
                    {...bemClassesAdminPane('text')}
                    children={warning.value}
                  />
                );
              })}
            </Fragment>
          );
        })}
      </div>
    );
  }

  render() {
    const { className, postId, posterId, topicId, post } = this.props;
    const defaultData = {
      entity: 'posts',
      entity_id: postId,
      poster_id: posterId,
      'data.topic_id': topicId,
      'data.post': post
    };

    return (
      <div {...classesBemForm({ extra: className })}>
        <div {...classesBemForm('flexColumn')}>
          <Row>
            <Col allPr={0}>
              <DataProvider
                url="forum/users-warning"
                query={{
                  posterId
                }}
                queryJson
                renderer={this.renderUsersWarning}
              />
            </Col>
          </Row>
          <Form
            controller="forum/users-warning"
            defaultValues={defaultData}
            showPopupValidationMessages
            onSubmit={this.onSubmit}
            data={defaultData}
            resetAfterSubmit
            flexColumn
          >
            <Row>
              <Col allPr={0}>
                <InputListBox
                  {...classesBemForm('list', 'noMaxH')}
                  dataBind="data.warnings"
                  dictValue="value"
                  nullValueItem={false}
                  // horizontal
                  noError
                />
              </Col>
            </Row>
            <div {...classesBemForm('footer', 'sticky')}>
              <Row allAuto allJustifyCFlexEnd {...classesBemForm('btnsContainer')}>
                <Col allPr={0} allPl={20}>
                  <Button
                    type="submit"
                    label="Вынести предупреждения"
                    theme={btnThemes.sky}
                    contentLeft
                    big
                  />
                </Col>
              </Row>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

export default NotificationsContent;
